import { render, staticRenderFns } from "./CallBreadcrumb.vue?vue&type=template&id=00c3896b"
import script from "./CallBreadcrumb.vue?vue&type=script&lang=js"
export * from "./CallBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports